var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c(
        "w-col",
        { attrs: { sm: "12", md: "6" } },
        [
          _c(
            "w-card",
            [
              _c("w-card-title", [_vm._v(_vm._s(_vm.mainAddressTitle))]),
              _c(
                "w-card-content",
                [
                  _vm.contact.Blocked
                    ? _c("w-info", {
                        staticClass: "warning mb",
                        attrs: {
                          ico: "exclamation-triangle",
                          "ico-lib": "fas",
                          text: _vm.$ct("contact-blocked"),
                        },
                      })
                    : _vm._e(),
                  _c("app-address", {
                    attrs: {
                      "group-id": _vm.contact.GroupID,
                      "contact-address": _vm.contact.MainAddress,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { sm: "12", md: "6" } },
        [
          _c(
            "w-card",
            [
              _c("w-card-title", [
                _vm._v(" " + _vm._s(_vm.$ct("titles.settings")) + " "),
              ]),
              _c(
                "w-card-content",
                [
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        { attrs: { xs: "12", md: "6" } },
                        [
                          _c("app-label", {
                            attrs: {
                              label: _vm.$ct("labels.Vat"),
                              value: _vm.contact.Vat,
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { xs: "12", md: "6" } },
                        [
                          _c("app-label", {
                            attrs: {
                              label: _vm.$ct("labels.Commercial"),
                              value: _vm.contact.CommercialVat,
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("app-label", {
                            attrs: {
                              value: _vm.contact.getPreferedPeppolEndpoint(),
                              label: _vm.$ct("peppol-endpoint-id"),
                              fancy: "",
                            },
                          }),
                        ],
                        1
                      ),
                      _c("w-col", { attrs: { xs: "12" } }, [
                        _c(
                          "div",
                          { style: { padding: "0 10px 0 10px" } },
                          [
                            _c("app-peppol-registration-status", {
                              attrs: { contact: _vm.contact },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        [
                          _c("app-label", {
                            attrs: {
                              value: _vm.vatRegimeName,
                              label: _vm.$ct("labels.VatRegime"),
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.contact.GroupID == 2
                    ? _c(
                        "w-row",
                        [
                          _c(
                            "w-col",
                            [
                              _c("app-label", {
                                attrs: {
                                  label: _vm.$ct("labels.iban"),
                                  value: _vm.contact.Iban,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.contact.GroupID == 2
                    ? _c(
                        "w-row",
                        [
                          _c(
                            "w-col",
                            [
                              _c("app-label", {
                                attrs: {
                                  label: _vm.$ct("labels.bic"),
                                  value: _vm.contact.Bic,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        { attrs: { xs: "12", md: "6" } },
                        [
                          _c("app-label", {
                            attrs: {
                              label: _vm.$ct("labels.payment_days"),
                              decimals: 0,
                              value: _vm.contact.PaymentDays,
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { xs: "12", md: "6" } },
                        [
                          _c("app-label", {
                            attrs: {
                              label: _vm.$ct("labels.payment_month"),
                              value: _vm.contact.PaymentEndMonth,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-row",
                    [
                      _vm.contact.GroupID == 1
                        ? _c(
                            "w-col",
                            { attrs: { xs: "12", md: "6" } },
                            [
                              _c("app-label", {
                                attrs: {
                                  label: _vm.$ct("labels.SellPriceCategory"),
                                  decimals: 0,
                                  value: _vm.priceCategory,
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "w-col",
                        { attrs: { xs: "12", md: "6" } },
                        [
                          _c("app-label", {
                            attrs: {
                              label: _vm.$ct("labels.default-journal"),
                              value: _vm.jounralName,
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { xs: "12", md: "6" } },
                        [
                          _c("app-label", {
                            attrs: {
                              value: _vm.contact.ComputedFriendlyID,
                              label: _vm.contactNrLabel,
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { xs: "6", md: "6" } },
                        [
                          _c("app-label", {
                            attrs: {
                              value: _vm.contact.Active,
                              label: _vm.$ct("labels.active"),
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { xs: "6", md: "6" } },
                        [
                          _c("app-label", {
                            attrs: {
                              value: _vm.contact.Blocked,
                              label: _vm.$ct("labels.blocked"),
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { xs: "6", md: "6" } },
                        [
                          _c("app-label", {
                            attrs: {
                              value: _vm.defaultLedgerAccount,
                              label: _vm.$ct("default-ledger-account"),
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.hasMollieModuleConfigured
                    ? _c(
                        "w-row",
                        [
                          _c(
                            "w-col",
                            { attrs: { xs: "12" } },
                            [
                              _c("app-label", {
                                attrs: {
                                  value: _vm.contact.MollieCustomerID,
                                  label: _vm.$ct("mollie-customer-id"),
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-card",
            { staticClass: "mt" },
            [
              _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("titles.discount")))]),
              _c(
                "w-card-content",
                [
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        { attrs: { md: "6", xs: "12" } },
                        [
                          _c("app-label", {
                            attrs: {
                              label: _vm.$ct("labels.discount"),
                              value: _vm.contact.Discount,
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { md: "6", xs: "12" } },
                        [
                          _c("app-label", {
                            attrs: {
                              label: _vm.$ct("labels.discountCash"),
                              value: _vm.contact.DiscountCash,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-card",
            { staticClass: "mt" },
            [
              _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("titles.reminders")))]),
              _c(
                "w-card-content",
                [
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        { attrs: { xs: "12", md: "6" } },
                        [
                          _c("app-label", {
                            attrs: {
                              value: _vm.maxRemindersText,
                              label: _vm.$ct("labels.maxReminder"),
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }